import React from 'react';
import PropTypes from 'prop-types';

import { __t } from '@mssgme/shared';
import styles from './SendButton.module.scss';

const SendButton = ({ href, ...rest }) => {
    return (
        <a className={styles.root} href={href} {...rest}>
            {__t('send')}
        </a>
    );
};

SendButton.propTypes = {
    href: PropTypes.string.isRequired,
};

export default SendButton;
